import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel'

import { Table, Tooltip } from 'antd';

class TinyNodeDataTable extends Component {

  state = {
    children: []
  }

  columns = [{
    title: 'NodeID',
    dataIndex: 'nodeID',
    key: 'nodeID',
    width: 150,
  }, {
    title: 'NodeTS',
    dataIndex: 'nodeTS',
    key: 'nodeTS',
    width: 75,
    render: (text, record) => {
      return (
        <Tooltip placement="right" title={moment.unix(text).format('L LTS')}>
          {text}
        </Tooltip>
      );
    }
  }, {
    title: 'ServerTS',
    dataIndex: 'serverTS',
    key: 'serverTS',
    width: 75,
    render: (text, record) => {
      return (
        <Tooltip placement="right" title={moment.unix(text).format('L LTS')}>
          {text}
        </Tooltip>
      );
    }
  }, {
    title: 'Occ',
    dataIndex: 'occ',
    key: 'occ',
    width: 50,
  }, {
    title: 'ParentID',
    dataIndex: 'parentID',
    key: 'parentID',
    width: 100,
  }, {
    title: 'tBoot',
    dataIndex: 'tBoot',
    key: 'tBoot',
    width: 100,
  }, {
    title: 'Čas přijetí',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 200,
    defaultSortOrder: 'descend',
    sorter: (a, b) => dateSorter(a.createdAt, b.createdAt),
    render: (text, record) => {
      return moment(text).format('L LTS');
    }
  }]

  render() {
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={this.columns}
        dataSource={this.props.data}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        style={{ border: '0px' }} />
    );
  }
}

export default TinyNodeDataTable;


// WEBPACK FOOTER //
// ./src/components/TinyNodeDataTable.js